import { saveProxyUrl } from "@shared/config";
import { installProxyAuthShim } from "@shared/api/proxyFetch";
import { wheelGet, wheelMutate } from "./api";

type StockForgePageApi = {
  get: <T>(path: string, opts?: { silent?: boolean }) => Promise<T>;
  post?: <T>(path: string, body?: unknown) => Promise<T>;
  put?: <T>(path: string, body?: unknown) => Promise<T>;
  delete?: <T>(path: string) => Promise<T>;
};

/** Same-origin /api and tenant calls use session cookies on the Linode host. */
function installFetchShim(): void {
  installProxyAuthShim();
}

function installWindowApi(): void {
  const win = window as Window & { API?: StockForgePageApi };
  if (win.API?.get) return;

  win.API = {
    get: (path) => wheelGet(path),
    post: (path, body) => wheelMutate("POST", path, body),
    put: (path, body) => wheelMutate("PUT", path, body),
    delete: (path) => wheelMutate("DELETE", path),
  };
}

/** Prepare web app to reuse shared modules that expect Stock Forge page APIs. */
export function installWebApiBridge(): void {
  try {
    if (!localStorage.getItem("sfe-proxy-url")) {
      saveProxyUrl(window.location.origin);
    }
  } catch {
    /* private mode */
  }
  installFetchShim();
  installWindowApi();
}
